import React from "react";
import { Route, useLocation } from "react-router";
import { Navigate, RouteProps } from "react-router-dom";
import { isLoginExpired } from "../../utils/identity-utils";

export const AuthenticatedRoute: React.FC<RouteProps> = ({ children, ...rest }) => {
  const location = useLocation()
  let unauthedRoute = unauthedRedirectRoute(location.pathname);

  if (!isLoginExpired()) return <>{children}</>;

  return <Navigate to={unauthedRoute} />;
};

export const unauthedRedirectRoute = (pathname: string) => {
  let unauthedRoute = "/welcome";
  if (pathname && pathname.toLowerCase().startsWith("/svber")) {
    unauthedRoute = "/svber/login";
  } else if (pathname && pathname.toLowerCase().startsWith("/connect")) {
    unauthedRoute = "/connect";
  }
  return unauthedRoute;
};
